import { APIGet } from '../services/API'


export const getRSSFeed = (args) => (dispatch, getState) => {

    // Get Site
    const { site } = getState().Settings;

    // Dispatch Result
    dispatch({
        type: 'GETTING_RSS_FEED',
        payload: {
            ui: "loading"
        }
    });

    let url = site+'/api/v1/rss/read';
    let qs = [];

    if(args.feed) qs.push('url='+args.feed);
    if(args.limit) qs.push('limit='+args.limit);
    let queryString = qs.join('&');

    url += '?'+queryString;

    // Send Request To Get Events
    APIGet(url)
    .then(res => res.json())
    .then(json => {
        dispatch({ type: 'GET_RSS_FEED_SUCCESS',payload: {ui:"success",items:json}});
    })
    .catch(e => {
        dispatch({ type: 'GET_RSS_FEED_ERROR',payload: {ui:"error",message:e}});
    })

}
